if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

jQuery(($) => {
    // Fade in hero text.
    let timeout = 300;
    $('.jumbotron h1').each((i, el) => {
        setTimeout(() => {
            $(el).fadeIn('slow');
        }, timeout * (i + 1));
    });

    setTimeout(() => {
        $('#nav .inner').addClass('loaded');
    }, 200);
});

// Fade (and slide up) home page titles
jQuery(() => {
    const elements     = document.querySelectorAll('.homepage-call-to-action, .homepage-call-to-action-small, .hidden');
    const windowHeight = window.innerHeight;

    /**
     *
     */
    const checkPosition = () => {
        for (let i = 0; i < elements.length; i++) {
            const element         = elements[i];
            const positionFromTop = elements[i].getBoundingClientRect().top;

            if (positionFromTop - windowHeight <= 0) {
                element.classList.add('fade-in-element');
                element.classList.remove('hidden');
            }
        }
    }

    window.addEventListener('scroll', checkPosition);
    checkPosition();
});

// Lazy load images
jQuery(() => {
    const images       = document.querySelectorAll('img[data-src]');
    const windowHeight = window.innerHeight;

    for (let i = 0; i < images.length; i++) {
        const element = images[i];
        const wrapper = element.closest('.homepage-portfolio-item-image-wrapper');

        const img = new Image();
        img.onload = () => {
            const { naturalWidth, naturalHeight } = img;
            const ratio  = wrapper.clientWidth / naturalWidth;
            let height = naturalHeight * ratio;
            if (height === 0) {
                height = naturalHeight;
            }

            wrapper.style.minHeight = `${height}px`;
            wrapper.querySelector('.homepage-image-placeholder').style.width = '100%';
            wrapper.querySelector('.homepage-image-placeholder').style.height = `${height}px`;
        };
        img.src = element.getAttribute('data-src');
    }

    /**
     *
     */
    const checkPosition = () => {
        for (let i = 0; i < images.length; i++) {
            if (!images[i].getAttribute('data-loaded')) {
                const element         = images[i];
                const positionFromTop = images[i].getBoundingClientRect().top;

                if (positionFromTop - windowHeight <= 0) {
                    element.setAttribute('src', element.getAttribute('data-src'));
                    element.setAttribute('data-loaded', 1);
                    element.classList.add('fade-in-element');
                }
            }
        }
    }

    window.addEventListener('scroll', checkPosition);
    checkPosition();
});
